import React from 'react';
import _ from 'lodash';
import Isvg from 'react-inlinesvg';
import Checkbox from 'app/components/general/Checkbox';
import {
  Card, CardBody, Collapse, ListGroup, ListGroupItem,
} from 'reactstrap';

import TickIcon from 'app/images/icons/tick2.svg';

interface IProductSelectorProps {
  selected: boolean;
  title: string;
  description: string;
  price: string;
  handleSelect: Function;
}
export default class ProductSelector extends React.Component<IProductSelectorProps> {
  static defaultProps: IProductSelectorProps = {
    selected: false,
    title: '',
    description: '',
    price: '',
    handleSelect: undefined,
  };

  coreProduct = (): React.ReactNode => (
    <div>
      <ListGroup flush>
        <ListGroupItem className="tick">
          <Isvg className="text-green d-inline-block with-margin-right" src={TickIcon} />
          <span className="d-block">Online match payments</span>
        </ListGroupItem>
        <ListGroupItem className="tick">
          <Isvg className="text-green d-inline-block with-margin-right" src={TickIcon} />
          <span className="d-block">Automated fixture integration</span>
        </ListGroupItem>
        <ListGroupItem className="tick">
          <Isvg className="text-green d-inline-block with-margin-right" src={TickIcon} />
          <span className="d-block">Match day dashboard</span>
        </ListGroupItem>
        <ListGroupItem className="tick">
          <Isvg className="text-green d-inline-block with-margin-right" src={TickIcon} />
          <span className="d-block">Support tracking EFTPOS credits and cash</span>
        </ListGroupItem>
        <ListGroupItem className="tick">
          <Isvg className="text-green d-inline-block with-margin-right" src={TickIcon} />
          <span className="d-block">Support club invoicing</span>
        </ListGroupItem>
        <ListGroupItem className="tick">
          <Isvg className="text-green d-inline-block with-margin-right" src={TickIcon} />
          <span className="d-block">Platform for teams and clubs to manage finances</span>
        </ListGroupItem>
      </ListGroup>
    </div>
  )

  plusProduct = (): React.ReactNode => (
    <div>
      <ListGroup flush>
        <ListGroupItem className="tick with-margin-bottom-10">
          <span className="d-block">Everything in Core, plus</span>
        </ListGroupItem>
        <ListGroupItem className="tick">
          <Isvg className="text-green d-inline-block with-margin-right" src={TickIcon} />
          <span className="d-block">Automated forfeit notifications</span>
        </ListGroupItem>
        <ListGroupItem className="tick">
          <Isvg className="text-green d-inline-block with-margin-right" src={TickIcon} />
          <span className="d-block">Online forfeit payments</span>
        </ListGroupItem>
        <ListGroupItem className="tick">
          <Isvg className="text-green d-inline-block with-margin-right" src={TickIcon} />
          <span className="d-block">Match payment reminders</span>
        </ListGroupItem>
        <ListGroupItem className="tick">
          <Isvg className="text-green d-inline-block with-margin-right" src={TickIcon} />
          <span className="d-block">Priority support</span>
        </ListGroupItem>
      </ListGroup>
    </div>
  )


  advancedProduct = (): React.ReactNode => (
    <div>
      <ListGroup flush>
        <ListGroupItem className="tick with-margin-bottom-10">
          <span className="d-block">Everything in Essentials, plus</span>
        </ListGroupItem>
        <ListGroupItem className="tick">
          <Isvg className="text-green d-inline-block with-margin-right" src={TickIcon} />
          <span className="d-block">Automated club invoicing</span>
        </ListGroupItem>
        <ListGroupItem className="tick">
          <Isvg className="text-green d-inline-block with-margin-right" src={TickIcon} />
          <span className="d-block">Advanced operational reporting</span>
        </ListGroupItem>
        <ListGroupItem className="tick">
          <Isvg className="text-green d-inline-block with-margin-right" src={TickIcon} />
          <span className="d-block">Concierge on-boarding for clubs</span>
        </ListGroupItem>
      </ListGroup>
    </div>
  )

  render(): React.ReactNode {
    return (
      <div
        className="product-selector"
        onClick={(e) => {
          e.stopPropagation();
          if (this.props.handleSelect !== undefined) {
            this.props.handleSelect();
          }
        }}
      >
        <div className="row">
          <div className="col">
            <Card className="no-shadow-3">
              <div
                className="row card-title"
              >
                <div className="col card-title-col">
                  <Checkbox
                    className="margin-right"
                    radio
                    checked={this.props.selected}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (this.props.handleSelect !== undefined) {
                        this.props.handleSelect();
                      }
                    }}
                  />
                  <span>{this.props.title}</span>
                  <span className="margin-left-auto text-weight-medium-bold">
                    {this.props.price}
                    {' '}
                    / month
                  </span>
                </div>
              </div>
              <CardBody>
                {this.props.title === 'Core' && this.coreProduct()}
                {this.props.title === 'Plus' && this.plusProduct()}
                {this.props.title === 'Advanced' && this.advancedProduct()}
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    );
  }
}
